export const actions = {
  backToStart: 'Zurück zur Startseite'
}